import React from 'react';
import sanitizeHtml from 'sanitize-html';

import SystemMessage from './SystemMessage';

type Props = {
  text: string
};

const SANITIZE_HTML_CONFIG = {
  allowedTags: ['br', 'a'],
  allowedAttributes: {
    a: ['href', 'class']
  }
};

class SystemChatMessageShipmentAdded extends SystemMessage<Props> {
  render() {
    const {
      text
    } = this.props;

    return (
      <React.Fragment>
        {this.renderIcon('brief-inside-circle-custom-fg')}
        <div className="messages-system-message__container">
          <div
            className="messages-system-message__bubble"
            data-qa="messages-system-message-offer-accepted__bubble"
          >
            <span dangerouslySetInnerHTML={{ __html: sanitizeHtml(text, SANITIZE_HTML_CONFIG) }} />
          </div>
        </div>
        {this.renderFooter()}
      </React.Fragment>
    );
  }
}

export default SystemChatMessageShipmentAdded;
